var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVideoWall = function SvgVideoWall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    strokeWidth: 1.2,
    x: 0.6,
    y: 3.6,
    width: 20.8,
    height: 14.8,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    d: "M7.5 4.5v13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    d: "M2.5 15.5h18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    d: "M14.5 4.5V11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M14.35 13.5h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    d: "M14.5 16.5V18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5 5.5-1 1m3-1L4 7M10.5 5.5l-1 1m3-1L11 7M17.5 5.5l-1 1m3-1L18 7",
    stroke: "#000"
  }))));
};

export default SvgVideoWall;